import { Routing } from '@singularsystems/neo-core';
import ClientAccountMappingView from '../ClientAccountMapping/Views/ClientAccountMappingView';
import EventMappingView from '../EventMapping/Views/EventMappingView';
import AssignInstrumentView from '../InstrumentMapping/components/AssignInstrumentComponent';
import InstrumentMappingView from '../InstrumentMapping/Views/InstrumentMappingView';
import AssignEventView from '../EventMapping/components/AssignEventComponent';
import TransactionInterceptionView from '../Transactions/Views/TransactionInterceptionView';
import FreeTextEventMappingView from '../EventFreeTextMapping/Views/FreeTextEventMappingView';
import ExcludedAccountsView from '../ExclusionAccounts/Views/ExcludedAccountsView';
import { AuthorisableRequests, ClientAccountMapping, EventMapping, ExcludedAccounts, FreeTextEventMapping, GenerateTransactions, InstrumentMapping, TransactionInterception } from '../../AccessControl/Models/Commands/Security/Roles';
import GenerateTransactionsView from '../GenerateTransactions/Views/GenerateTransactionsView';
import AuthorisableTransactionsView from '../../Maintenance/AuthorisableUpdateRequests/Transactions/Views/AuthorisableTransactionsView';

const InterceptionRoutes: Routing.IMenuRoute = {
    name: "Interception",
    expanded: false,
    icon: "hands-helping",
    exact: true,
    allowAnonymous:false,
    role: InstrumentMapping.Access,
    children: [
        {
            name: "Instrument Mapping",
            path: "/interception/instrumentMapping",
            icon: "eye",
            component: InstrumentMappingView,
            allowAnonymous: true,
            role: InstrumentMapping.Access
        },
        {
            name: "Event Mapping",
            path: "/interception/eventMapping",
            icon: "eye",
            component: EventMappingView,
            allowAnonymous: true,
            role: EventMapping.Access
        },
        {
            name: "Free Text Event Mapping",
            path: "/interception/freeTextEventMapping",
            icon: "keyboard",
            component: FreeTextEventMappingView,
            allowAnonymous: true,
            role: FreeTextEventMapping.Access
        },
        {
            name: "Client Account Mapping",
            path: "/clientAccountMapping",
            component: ClientAccountMappingView,
            icon: "users",
            role: ClientAccountMapping.Access
        },
        {
            name: "Authorisable Requests",
            path: "/authorisedTransactions",
            component: AuthorisableTransactionsView,
            icon: "hand-holding-usd",
            role: AuthorisableRequests.Access
        },
        {
            name: "Transactions",
            path: "/transactions",
            component: TransactionInterceptionView,
            role: TransactionInterception.Access,
            icon: "hand-holding-usd"
        },
        {
            name: "Generate Transactions",
            path: "/generateTransactions",
            component: GenerateTransactionsView,
            icon: "hand-holding-usd",
            role: GenerateTransactions.Access
        }
    ]
}

const PureRoutes: Routing.IRoute[] = [
    {
        path: "/assignInstrument", component: AssignInstrumentView, role: InstrumentMapping.Access
    },
    {
        path: "/assignEvent", component: AssignEventView, role: EventMapping.Access
    },
    {
        path: "/accountExclusions", component: ExcludedAccountsView, role: ExcludedAccounts.Access
    }
];

export {
    InterceptionRoutes,
    PureRoutes
}